type NavigatorLike = {
  userAgent?: string
  platform?: string
  maxTouchPoints?: number
}

/**
 * iOS Safari は font-size < 16px の form にフォーカスするとページを自動ズームする。
 * gp-front と同じく、iOS / iPadOS だけ viewport に maximum-scale=1.0 を足して防ぐ。
 *
 * iOS 10 以降はユーザーのピンチズームは無視されず残る一方、フォーカス時の自動ズームは止まる。
 * Android 等には付けない（maximum-scale=1 がピンチズームまで封じるため）。
 *
 * iPadOS 13+ は UA が Macintosh（iPad 文字列なし）になることがあるため、
 * Macintosh+Mobile と MacIntel+タッチ も iPadOS として扱う。
 *
 * @see growthpalette-front client/ajax/src/modules/initiator.ts Initiator.initViewPort
 */
export function applyIosInputZoomPrevention(
  navigatorLike: NavigatorLike = typeof navigator !== 'undefined' ? navigator : {},
  documentRef: Document = document,
): void {
  if (!isAppleTouchDevice(navigatorLike)) return

  const meta = documentRef.querySelector<HTMLMetaElement>('meta[name="viewport"]')
  if (!meta) return

  const current = (meta.getAttribute('content') ?? '').replace(/\s/g, '')
  if (!current) return

  const parts = current
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean)
    .filter((part) => !part.toLowerCase().startsWith('maximum-scale='))

  parts.push('maximum-scale=1.0')
  meta.setAttribute('content', parts.join(','))
}

function isAppleTouchDevice({
  userAgent = '',
  platform = '',
  maxTouchPoints = 0,
}: NavigatorLike): boolean {
  if (/iphone|ipod|ipad/i.test(userAgent)) return true
  // iPadOS 13+ が Mobile Safari として振る舞うときの UA
  if (/macintosh/i.test(userAgent) && /mobile/i.test(userAgent)) return true
  // iPadOS 13+ がデスクトップ相当 UA（iPad 文字列なし）のとき
  if (platform === 'MacIntel' && maxTouchPoints > 1) return true
  return false
}
